import type { StoryStateType } from "../types";

export const handleDndParent = (
  state: StoryStateType,
  payload: {
    newParentId: string;
    currentParentId: string;
    id: string;
    overId: string;
  },
) => {
  const { newParentId, currentParentId, id, overId } = payload;
  const entity = state.flatContentLayers[id];
  if (!entity) return;
  const currentParent = state.flatContentLayers[currentParentId];
  if (currentParent) {
    const index = currentParent.childIds.indexOf(id);
    currentParent.childIds.splice(index, 1);
  }
  const newParent = state.flatContentLayers[newParentId];
  if (!newParent) return;
  const index = newParent.childIds.indexOf(overId);
  newParent.childIds.splice(index, 0, id);
  entity.parentId = newParentId;
};
